/**
 * Interactive filter for Distribution Lines
 * Filters by letter and manufacturer search
 */
import { DISTRIBUTION_DATA } from "./distribution-data.js";

export function initDistributionLines() {
  const container = document.querySelector("[data-distribution-lines]");
  if (!container) return;

  const filterLetter = container.querySelector("[data-filter-letter]");
  const filterManufacturer = container.querySelector("[data-filter-manufacturer]");
  const resultsEl = container.querySelector("[data-distribution-results]");
  const countEl = container.querySelector("[data-distribution-count]");
  const clearBtn = container.querySelector("[data-filter-clear]");

  if (!resultsEl) return;

  let state = {
    letter: "",
    manufacturer: "",
  };

  function getUniqueLetters(arr) {
    const set = new Set(arr.map((m) => m.letter));
    return [...set].sort();
  }

  function buildLetterFilter() {
    if (!filterLetter) return;
    const letters = getUniqueLetters(DISTRIBUTION_DATA.manufacturers);
    filterLetter.innerHTML =
      '<option value="">All letters</option>' +
      letters.map((l) => `<option value="${l}">${l}</option>`).join("");
  }

  function matchesFilters(m) {
    if (state.letter && m.letter !== state.letter) return false;
    const q = state.manufacturer.trim().toLowerCase();
    if (q && !m.name.toLowerCase().includes(q)) return false;
    return true;
  }

  function renderResults() {
    const filtered = DISTRIBUTION_DATA.manufacturers.filter(matchesFilters);

    const byLetter = {};
    filtered.forEach((m) => {
      if (!byLetter[m.letter]) byLetter[m.letter] = [];
      byLetter[m.letter].push(m);
    });
    const letters = Object.keys(byLetter).sort();

    let html = "";
    letters.forEach((letter) => {
      html += `<div class="dist-letter-group" id="letter-${letter}">
        <h3 class="dist-letter-heading">${letter}</h3>
        <ul class="dist-manufacturer-list">`;
      byLetter[letter].forEach((m) => {
        html += `<li>${m.name}</li>`;
      });
      html += "</ul></div>";
    });

    if (filtered.length === 0) {
      html =
        '<p class="dist-no-results">No manufacturers match your filters. Try adjusting your selection.</p>';
    }

    resultsEl.innerHTML = html;

    if (countEl) {
      countEl.textContent = `${filtered.length} manufacturer${filtered.length !== 1 ? "s" : ""}`;
    }
  }

  function updateFilters() {
    state.letter = filterLetter?.value || "";
    state.manufacturer = filterManufacturer?.value || "";
    renderResults();
  }

  buildLetterFilter();
  if (filterLetter) filterLetter.addEventListener("change", updateFilters);
  if (filterManufacturer) {
    filterManufacturer.addEventListener("input", updateFilters);
  }
  if (clearBtn) {
    clearBtn.addEventListener("click", () => {
      if (filterLetter) filterLetter.value = "";
      if (filterManufacturer) filterManufacturer.value = "";
      updateFilters();
    });
  }

  renderResults();
}
